import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined'
import { IconButton, InputAdornment, Tooltip } from '@mui/material'
import { MuiTelInput } from 'mui-tel-input'
import { Controller } from 'react-hook-form'

import { phoneNumberTooltip } from 'helpers/phoneValidation.helpers'

import { ControlledTextFieldProps } from './ControlledTextField'

export const ControlledTelephoneNumWithCountryCode = (props: ControlledTextFieldProps) => {
  const {
    control,
    name,
    label,
    defaultValue = '',
    disabled,
    readOnly,
    fullWidth = true,
    min,
    startAdornment,
    endAdornment,
    hideEndAdornment = false,
    variant,
    ...otherProps
  } = props

  const handleOnCallClick = (telephoneNumber: string) => window.open(`tel:${telephoneNumber}`)

  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue}
      render={({ field: { ref, onChange, ...restField } }) => (
        <Tooltip title={phoneNumberTooltip} arrow placement='top'>
          <MuiTelInput
            {...restField}
            inputRef={ref}
            label={label}
            variant={variant}
            inputProps={{ min }}
            fullWidth={fullWidth}
            disabled={disabled}
            defaultCountry={'GB'}
            forceCallingCode={true}
            focusOnSelectCountry={true}
            flagSize='medium'
            onChange={(value: string) => {
              onChange(value)
            }}
            InputProps={{
              readOnly,
              endAdornment: endAdornment ? (
                <InputAdornment position='end'>{endAdornment}</InputAdornment>
              ) : !hideEndAdornment ? (
                <InputAdornment position='end'>
                  <IconButton aria-label='call' onClick={() => handleOnCallClick(restField.value)}>
                    <PhoneOutlinedIcon />
                  </IconButton>
                </InputAdornment>
              ) : undefined,
            }}
            {...otherProps}
          />
        </Tooltip>
      )}
    />
  )
}
